module.exports = __webpack_public_path__ + "assets/logo-hero-cinza.d8b9fc1e.svg";